import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { MODALS } from '@/configs/modals';
import { useModals } from '@/hooks/useModals';
import { useTranslation } from 'react-i18next';
import { isFunction } from '@/utils/helpers';

const ConfirmModal = () => {
  const { t } = useTranslation();
  const modalId = MODALS.confirm;
  const { params, modalClose } = useModals(modalId);
  const {
    isOpen,
    onOk,
    onCancel,
    title,
    text,
    btnOkText = t('confirm_modal.btn_ok'),
    btnOkColor = 'primary',
    btnCancelText = t('confirm_modal.btn_cancel'),
    btnCancelColor = 'secondary',
    isDeleteType,
  } = params || {};

  const handleClickOk = () => {
    isFunction(onOk) && onOk();
    closeModal();
  };
  const handleClickCancel = () => {
    isFunction(onCancel) && onCancel();
    closeModal();
  };
  const closeModal = () => {
    modalClose(modalId);
  }

  return (
    <Modal
      isOpen={isOpen}
      onClosed={handleClickCancel}
      className={MODALS.confirm}
      centered={true}
    >
      {!!title && (
        <ModalHeader tag="h4" toggle={handleClickCancel}>
          {title}
        </ModalHeader>
      )}
      {!!text && (
        <ModalBody>
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </ModalBody>
      )}
      <ModalFooter>
        <Button color={btnCancelColor} onClick={handleClickCancel}>
          {btnCancelText}
        </Button>
        <Button
          color={isDeleteType ? 'danger' : btnOkColor}
          onClick={handleClickOk}
        >
          {btnOkText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
